<div class="admin-reviews-modal">
  <button class="admin-reviews-modal__close" (click)="close()">
    <app-enfaf-icon svgIconName="x" iconSize="18px"></app-enfaf-icon>
  </button>

  <div class="admin-reviews-modal__body">
    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner></mat-spinner>
      </div>
    }

    @if (!isLoading && reviewsData) {
      <!-- Summary Section -->
      <div class="reviews-summary">
        <div class="reviews-summary__rating-text">
          <span class="reviews-summary__number">{{ formatAverageRating(reviewsData.summary.averageRating) }}</span
          ><span class="reviews-summary__denominator">/5</span>
        </div>
        <div class="reviews-summary__stars">
          @for (star of getStarArray(); track star) {
            <div class="star-container-blue">
              <app-enfaf-icon svgIconName="star-blue-outline" iconSize="35px" class="star-background"></app-enfaf-icon>
              @if (star <= getFullStars(reviewsData.summary.averageRating)) {
                <app-enfaf-icon svgIconName="star-blue-filled" iconSize="35px" class="star-overlay"></app-enfaf-icon>
              } @else if (
                star === getFullStars(reviewsData.summary.averageRating) + 1 && getPartialStarPercentage(reviewsData.summary.averageRating) > 0
              ) {
                <div class="star-overlay-clip" [style.width.%]="getPartialStarPercentage(reviewsData.summary.averageRating)">
                  <app-enfaf-icon svgIconName="star-blue-filled" iconSize="35px" class="star-overlay"></app-enfaf-icon>
                </div>
              }
            </div>
          }
        </div>
        <span class="reviews-summary__count">{{ reviewsData.summary.ratingsCount }} reviews</span>
      </div>

      <!-- Reviews List (fixed height) -->
      <div class="reviews-list-container">
        @if (currentPageReviews.length > 0) {
          <div class="reviews-list" [class.reviews-list--full]="shouldDistributeReviewCards">
            @for (review of currentPageReviews; track review.classRatingId) {
              <div class="review-item" [class.review-item--expanded]="isExpanded(review.classRatingId)">
                <div class="review-item__header">
                  <div class="review-item__user">
                    <div class="review-item__avatar">
                      @if (review.user?.profileImage) {
                        <img [src]="review.user?.profileImage || ''" [alt]="review.user?.name || 'Usuario'" />
                      } @else {
                        <svg
                          class="user-avatar-placeholder"
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          aria-hidden="true"
                        >
                          <rect x="0.25" y="0.25" width="39.5" height="39.5" rx="19.75" fill="#2D6BEE" fill-opacity="0.5" />
                          <rect x="0.25" y="0.25" width="39.5" height="39.5" rx="19.75" stroke="#2D6BEE" stroke-width="0.5" stroke-dasharray="1 1" />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M20.0003 14.5C18.8037 14.5 17.8337 15.47 17.8337 16.6667C17.8337 17.8633 18.8037 18.8333 20.0003 18.8333C21.197 18.8333 22.167 17.8633 22.167 16.6667C22.167 15.47 21.197 14.5 20.0003 14.5ZM16.8337 16.6667C16.8337 14.9178 18.2514 13.5 20.0003 13.5C21.7492 13.5 23.167 14.9178 23.167 16.6667C23.167 18.4156 21.7492 19.8333 20.0003 19.8333C18.2514 19.8333 16.8337 18.4156 16.8337 16.6667ZM15.0945 22.4275C15.6884 21.8336 16.4938 21.5 17.3337 21.5H22.667C23.5068 21.5 24.3123 21.8336 24.9062 22.4275C25.5 23.0214 25.8337 23.8268 25.8337 24.6667V26C25.8337 26.2761 25.6098 26.5 25.3337 26.5C25.0575 26.5 24.8337 26.2761 24.8337 26V24.6667C24.8337 24.092 24.6054 23.5409 24.1991 23.1346C23.7927 22.7283 23.2416 22.5 22.667 22.5H17.3337C16.759 22.5 16.2079 22.7283 15.8016 23.1346C15.3953 23.5409 15.167 24.092 15.167 24.6667V26C15.167 26.2761 14.9431 26.5 14.667 26.5C14.3908 26.5 14.167 26.2761 14.167 26V24.6667C14.167 23.8268 14.5006 23.0214 15.0945 22.4275Z"
                            fill="#111111"
                          />
                        </svg>
                      }
                    </div>
                    <span class="review-item__name">
                      {{ review.user ? review.user.name + ' ' + review.user.lastname : 'Nombre Apellidos' }}
                    </span>
                  </div>
                  <div class="review-item__rating-wrapper">
                    <div class="review-item__stars">
                      @for (star of [1, 2, 3, 4, 5]; track star) {
                        <div class="star-container-small">
                          <app-enfaf-icon svgIconName="star-gray-outline" iconSize="15px" class="star-background-small"></app-enfaf-icon>
                          @if (star <= review.rating) {
                            <app-enfaf-icon svgIconName="star-gray-filled" iconSize="15px" class="star-overlay-small"></app-enfaf-icon>
                          } @else if (star === Math.floor(review.rating) + 1 && review.rating % 1 !== 0) {
                            <div class="star-overlay-clip-small" [style.width.%]="getReviewPartialStarPercentage(review.rating)">
                              <app-enfaf-icon svgIconName="star-gray-filled" iconSize="15px" class="star-overlay-small"></app-enfaf-icon>
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <span class="review-item__rating-text">
                      <span class="review-item__rating-number">{{ review.rating }}</span
                      ><span class="review-item__rating-denom">/5</span>
                    </span>
                  </div>
                </div>

                <div class="review-item__comment-area">
                  @if (review.comment) {
                    @if (!isExpanded(review.classRatingId)) {
                      <p class="review-item__comment review-item__comment--clamped">
                        <span #commentEl [attr.data-review-id]="review.classRatingId" class="review-item__comment-text">{{ review.comment }}</span>
                        @if (isTruncated(review.classRatingId)) {
                          <button class="review-item__more-btn" (click)="toggleExpanded(review.classRatingId)">Más</button>
                        }
                      </p>
                    } @else {
                      <p class="review-item__comment">
                        {{ review.comment }}
                        <button class="review-item__more-btn" (click)="toggleExpanded(review.classRatingId)">Menos</button>
                      </p>
                    }
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="empty-state">
            <p>No hay valoraciones para esta clase</p>
          </div>
        }
      </div>
    }
  </div>

  <!-- Footer with pagination -->
  @if (!isLoading && reviewsData) {
    <div class="admin-reviews-modal__footer">
      <button class="pagination-btn" [disabled]="currentPage === 0" (click)="prevPage()"> Atrás </button>

      <div class="pagination-numbers">
        @for (pageNum of getPaginationNumbers(); track pageNum) {
          <button class="pagination-number" [class.active]="pageNum === currentPage" (click)="goToPage(pageNum)">
            {{ pageNum + 1 }}
          </button>
        }
      </div>

      <button class="pagination-btn" [disabled]="currentPage === totalPages - 1" (click)="nextPage()"> Siguiente </button>
    </div>
  }
</div>
